/* eslint-disable max-len */
import { defineMessages } from 'react-intl';

export default defineMessages({
    PrivateMotorRenewalIsReady: {
        id: 'cep.components.sgRenewalProposalTile.RenewalIsReady',
        defaultMessage: 'Your Motor insurance renewal is ready'
    },
    PrivateHomeRenewalIsReady: {
        id: 'cep.components.sgRenewalProposalTile.HomeRenewalIsReady',
        defaultMessage: 'Your Home insurance renewal is ready'
    },
    PrivateTravelRenewalIsReady: {
        id: 'cep.components.sgRenewalProposalTile.PrivateTravelRenewalIsReady',
        defaultMessage: 'Your travel insurance renewal is ready'
    },
    NoNeedToContact: {
        id: 'cep.components.sgRenewalProposalTile.NoNeedToContact',
        defaultMessage: 'There is no need to contact us.'
    },
    AutoRenew: {
        id: 'cep.components.sgRenewalProposalTile.AutoRenew',
        defaultMessage: 'Your policy will automatically renew in {days} days'
    },
    TotalPrice: {
        id: 'cep.components.sgRenewalProposalTile.TotalPrice',
        defaultMessage: 'Total price'
    },
    ViewDetails: {
        id: 'cep.components.sgRenewalProposalTile.ViewDetails',
        defaultMessage: 'View details'
    },
    Review: {
        id: 'cep.components.sgRenewalProposalTile.Review',
        defaultMessage: 'Review'
    },
    MigrationBannerText: {
        id: 'cep.components.sgRenewalProposalTile.MigrationBannerText',
        defaultMessage: 'This year we need to tell you about a change to your policy.  Please take a moment to review your renewal documentation which outlines the changes to your cover and the key additional benefits that you will receive. If you have any questions please contact us via '
    },
    MigrationBannerTextWebChat: {
        id: 'cep.components.SgEndorsementInfo.MigrationBannerTextWebChat',
        defaultMessage: 'web chat.'
    },
});
